import { call, put, takeLatest } from "redux-saga/effects"

import { getDummyResult } from "./dummyData"
import Creators, { RequestsDigitalReceiptTypes as constants } from "./reducer"
import * as services from "./services"

// The backend has no Digital receipt admin endpoint yet. Each saga tries the real
// service and, if it is unavailable (404 / network), falls back to dummy data so the
// admin view renders. When the endpoint ships, delete the dummy fallbacks + dummyData.js.

function* getListSaga(action) {
  const params = action.payload || {}
  try {
    const res = yield call(services.getDigitalReceiptRequests, params)
    if (res?.ok && res.data?.results) {
      yield put(Creators.getRequestsDigitalReceiptSuccess(res.data))
      return
    }
  } catch (e) {
    // fall through to dummy data
  }
  yield put(Creators.getRequestsDigitalReceiptSuccess(getDummyResult(params)))
}

function* updateStatusSaga(action) {
  const { id, status } = action.payload || {}
  try {
    yield call(services.updateDigitalReceiptStatus, { id, status })
  } catch (e) {
    // optimistic local update below regardless
  }
  yield put(Creators.updateRequestsDigitalReceiptStatusSuccess({ id, status }))
}

function* reviewUpdateSaga(action) {
  const { id, action: reviewAction } = action.payload || {}
  try {
    yield call(services.reviewDigitalReceiptUpdate, { id, action: reviewAction })
  } catch (e) {
    // optimistic local update below regardless
  }
  yield put(Creators.reviewDigitalReceiptUpdateSuccess({ id, action: reviewAction }))
}

export default function* apiSaga() {
  yield takeLatest(constants.GET_REQUESTS_DIGITAL_RECEIPT_REQUEST, getListSaga)
  yield takeLatest(constants.UPDATE_REQUESTS_DIGITAL_RECEIPT_STATUS_REQUEST, updateStatusSaga)
  yield takeLatest(constants.REVIEW_DIGITAL_RECEIPT_UPDATE_REQUEST, reviewUpdateSaga)
}
